import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { LogoSvg } from '~/components/icons'

export const GHRHeader = () => {
	const [hoveredDropdown, setHoveredDropdown] = useState(null)

	const handleMouseEnter = (dropdownId) => {
		setHoveredDropdown(dropdownId)
	}

	const handleMouseLeave = () => {
		setHoveredDropdown(null)
	}

	return (
		<>
			<Helmet>
				<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
				<meta http-equiv="X-UA-Compatible" content="IE=Edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />
				<title>Staffing Solutions for Healthcare Professionals | GHR Healthcare</title>
				<meta
					name="description"
					content="Discover GHR Healthcare&#39;s tailored staffing solutions for healthcare organizations. Explore job opportunities, staffing services, and industry expertise. Partner with us to elevate your healthcare workforce today!"
				/>
				<link rel="preconnect" href="https://static.ghrhealthcare.com/" />
				<link rel="canonical" href="https://www.ghrhealthcare.com/" />
				<link href="/assets/ghr/scripts/style.css" rel="stylesheet" link="preload" />
				<link rel="shortcut icon" href="https://www.ghrhealthcare.com/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="https://static.ghrhealthcare.com/images/favicons/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="https://static.ghrhealthcare.com/images/favicons/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="https://static.ghrhealthcare.com/images/favicons/favicon-16x16.png" />
				<link rel="manifest" href="https://static.ghrhealthcare.com/images/favicons/site.webmanifest" />
				<link rel="mask-icon" href="https://static.ghrhealthcare.com/images/favicons/safari-pinned-tab.svg" color="#009dd6" />
				<meta name="msapplication-TileColor" content="#ff0000" />
				<meta name="msapplication-config" content="https://static.ghrhealthcare.com/images/favicons/browserconfig.xml" />
				<meta name="theme-color" content="#ffffff" />
				<meta property="og:url" content="https://www.ghrhealthcare.com/index" />
				<meta property="og:title" content="Home | GHR Healthcare" />
				<meta
					property="og:description"
					content="Discover GHR Healthcare&#39;s tailored staffing solutions for healthcare organizations. Explore job opportunities, staffing services, and industry expertise. Partner with us to elevate your healthcare workforce today!"
				/>
				<script async="" src="/assets/ghr/scripts/clarity.js"></script>
				<script async="" src="/assets/ghr/scripts/oktrk.js"></script>
				<script async="" src="/assets/ghr/scripts/mvmrui0cqx"></script>
				<script src="/assets/ghr/scripts/813742746898208" async=""></script>
				<script async="" src="/assets/ghr/scripts/fbevents.js"></script>
				<script type="text/javascript" async="" src="/assets/ghr/scripts/js"></script>
				<script type="text/javascript" async="" src="/assets/ghr/scripts/hf.js"></script>

				<script data-cfasync="false" data-pagespeed-no-defer="">
					{` var gtm4wp_datalayer_name = "dataLayer";
  var dataLayer = dataLayer || [];
  `}
				</script>

				<script data-cfasync="false">
					{`(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-59KD54Q");
  `}
				</script>

				<script type="text/javascript">
					{`window.hfAccountId = "9dd8e1aa-a00b-4c90-a693-343da79aff05";
  window.hfDomain = "https://api.herefish.com";
  (function () {
    var hf = document.createElement("script");
    hf.type = "text/javascript";
    hf.async = true;
    hf.src = window.hfDomain + "/scripts/hf.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hf, s);
  })();`}
				</script>
				<script type="application/ld+json" nonce="">
					{`{
    "@context": "http://schema.org",
    "@type": "WebSite",
    "url": "https://www.ghrhealthcare.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.ghrhealthcare.com/search-results?query={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }`}
				</script>
				<link href="/assets/ghr/scripts/widget_base.css" type="text/css" rel="stylesheet" />
				<link type="text/css" rel="stylesheet" id="uw-stylesheet-udf" href="/assets/ghr/scripts/udf.css" />
				<link href="/assets/ghr/scripts/widget_lazy.css" type="text/css" rel="stylesheet" />
				<link href="/assets/ghr/scripts/style(1).css" type="text/css" rel="stylesheet" />
			</Helmet>

			<div id="search-container" className="search-container d-none d-lg-block">
				<div className="container-xxl">
					<div className="row justify-content-between">
						<div className="col-12 rel">
							<form className="search-form-top" method="get" action="https://www.ghrhealthcare.com/search-results">
								<div className="d-flex justify-content-center">
									<div className="top-search-input">
										<input type="text" id="search-query" className="search-query form-control" name="query" title="Search Input" placeholder="Search" />
									</div>
									<button type="submit" className="btn btn-srch">
										Go
									</button>
								</div>
							</form>
							<button className="btn-link close-search closeit">
								<span className="icon-close-circle"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<header className="fixed-top home scrolled">
				<div className="branding-top home">
					<div className="container-xxl">
						<div className="row mt-spec">
							<div className="col-6">
								<div className="logo-container">
									<a href="https://www.ghrhealthcare.com/">
										<LogoSvg />
										{/* <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" width="170.8" height="60.28" viewBox="0 0 170.8 60.28">
											<defs>
												<radialgradient
													id="radial-gradient"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
													gradientUnits="userSpaceOnUse"
												>
													<stop offset="0" stop-color="#5ea5d5" stop-opacity="0"></stop>
													<stop offset=".11" stop-color="#55a4d5" stop-opacity=".18"></stop>
													<stop offset=".28" stop-color="#3da1d6" stop-opacity=".47"></stop>
													<stop offset=".5" stop-color="#159cd8" stop-opacity=".83"></stop>
													<stop offset=".6" stop-color="#0099d9"></stop>
													<stop offset="1" stop-color="#222c84"></stop>
												</radialgradient>
												<radialgradient id="radial-gradient-2" cx="-212.03" cy="414.19" fx="-212.03" fy="414.19" r="1"></radialgradient>
												<radialgradient
													id="radial-gradient-3"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
												></radialgradient>
												<radialgradient
													id="radial-gradient-4"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
												></radialgradient>
												<radialgradient id="radial-gradient-5" cx="-212.03" fx="-212.03" r="1"></radialgradient>
												<radialgradient id="radial-gradient-6" cy="414.19" fy="414.19" r="1"></radialgradient>
												<radialgradient
													id="radial-gradient-7"
													cx="-212.03"
													cy="414.18"
													fx="-212.03"
													fy="414.18"
													r="1"
													gradientTransform="translate(6433.83 12518.15) scale(30.2 -30.15)"
												></radialgradient>
												<radialgradient
													id="radial-gradient-8"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
												></radialgradient>
												<radialgradient
													id="radial-gradient-9"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
												></radialgradient>
												<radialgradient
													id="radial-gradient-10"
													cx="-212.03"
													cy="414.18"
													fx="-212.03"
													fy="414.18"
													r="1"
													gradientTransform="translate(6436.73 12523.81) scale(30.21 -30.16)"
												></radialgradient>
												<radialgradient
													id="radial-gradient-11"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
												></radialgradient>
												<radialgradient
													id="radial-gradient-12"
													cx="-212.03"
													cy="414.19"
													fx="-212.03"
													fy="414.19"
													r="1"
													gradientTransform="translate(6437.76 12525.76) scale(30.22 -30.17)"
												></radialgradient>
											</defs>
											<g id="Layer_1-2">
												<path className="cls-13" d="m81.8,56.94v-5.81h-6.39v5.81h-2.3v-13.96h2.3v5.98h6.39v-5.98h2.32v13.96h-2.32Z"></path>
												<path
													className="cls-13"
													d="m95.52,54.18c-.5,1.63-1.97,2.95-4.22,2.95-2.53,0-4.77-1.83-4.77-5,0-2.95,2.19-4.9,4.55-4.9,2.88,0,4.57,1.89,4.57,4.85,0,.36-.04.67-.06.71h-6.83c.06,1.41,1.17,2.43,2.55,2.43s2.03-.71,2.34-1.63l1.88.6Zm-2.13-3.02c-.04-1.09-.77-2.07-2.3-2.07-1.4,0-2.21,1.07-2.28,2.07h4.58Z"
												></path>
												<path
													className="cls-13"
													d="m100.74,51.5l2.4-.36c.54-.08.69-.34.69-.67,0-.78-.54-1.41-1.77-1.41s-1.82.75-1.92,1.69l-2.03-.46c.18-1.61,1.63-3.04,3.93-3.04,2.88,0,3.97,1.63,3.97,3.48v4.64c0,.84.1,1.4.12,1.49h-2.07c-.02-.06-.1-.44-.1-1.19-.44.71-1.37,1.47-2.88,1.47-1.96,0-3.16-1.34-3.16-2.82,0-1.68,1.24-2.6,2.83-2.82Zm3.09,1.47v-.42l-2.44.36c-.69.12-1.25.5-1.25,1.27,0,.63.48,1.21,1.37,1.21,1.24,0,2.32-.59,2.32-2.41Z"
												></path>
												<path className="cls-13" d="m109.27,56.85v-13.87h2.22v13.87h-2.22Z"></path>
												<path
													className="cls-13"
													d="m117.58,47.52h1.94v1.97h-1.94v4.33c0,.82.36,1.17,1.19,1.17.31,0,.67-.06.77-.08v1.83c-.14.06-.56.21-1.37.21-1.73,0-2.8-1.03-2.8-2.78v-4.69h-1.73v-1.96h.48c1,0,1.43-.63,1.43-1.45v-1.4h2.02v2.85Z"
												></path>
												<path
													className="cls-13"
													d="m124.5,56.85h-2.22v-13.87h2.22v5.44c.63-.82,1.69-1.17,2.66-1.17,2.3,0,3.42,1.65,3.42,3.7v5.89h-2.23v-5.51c0-1.15-.52-2.07-1.92-2.07-1.23,0-1.9.92-1.93,2.11v5.47Z"
												></path>
												<path
													className="cls-13"
													d="m135.17,52.17c0,1.87,1.21,2.93,2.61,2.93s2.13-1.01,2.34-1.73l1.96.71c-.44,1.45-1.84,3.04-4.29,3.04-2.74,0-4.83-2.13-4.83-4.96s2.09-4.94,4.77-4.94c2.51,0,3.89,1.57,4.27,3.06l-1.99.73c-.21-.82-.84-1.75-2.26-1.75-1.37.02-2.57,1.04-2.57,2.91Z"
												></path>
												<path
													className="cls-13"
													d="m146.62,51.5l2.4-.36c.54-.08.69-.34.69-.67,0-.78-.54-1.41-1.77-1.41s-1.82.75-1.92,1.69l-2.03-.46c.18-1.61,1.63-3.04,3.93-3.04,2.88,0,3.97,1.63,3.97,3.48v4.64c0,.84.1,1.4.12,1.49h-2.07c-.02-.06-.1-.44-.1-1.19-.44.71-1.37,1.47-2.88,1.47-1.96,0-3.16-1.34-3.16-2.82,0-1.68,1.24-2.6,2.83-2.82Zm3.09,1.47v-.42l-2.44.36c-.69.12-1.25.5-1.25,1.27,0,.63.48,1.21,1.37,1.21,1.25,0,2.32-.59,2.32-2.41Z"
												></path>
												<path
													className="cls-13"
													d="m160.25,49.72c-.24-.04-.5-.06-.73-.06-1.73,0-2.51,1-2.51,2.74v4.44h-2.22v-9.32h2.17v1.49c.44-1.01,1.47-1.61,2.7-1.61.26,0,.5.04.6.06v2.26h0Z"
												></path>
												<path
													className="cls-13"
													d="m170.67,54.18c-.5,1.63-1.97,2.95-4.22,2.95-2.53,0-4.77-1.83-4.77-5,0-2.95,2.19-4.9,4.55-4.9,2.88,0,4.57,1.89,4.57,4.85,0,.36-.04.67-.06.71h-6.83c.06,1.41,1.17,2.43,2.55,2.43s2.03-.71,2.34-1.63l1.88.6Zm-2.13-3.02c-.04-1.09-.77-2.07-2.3-2.07-1.4,0-2.21,1.07-2.28,2.07h4.58Z"
												></path>
												<path className="cls-13" d="m129.72,3.36h6.95v34.17h-6.95v-14.5h-14.77v14.5h-7V3.36h7v13.52h14.77V3.36Z"></path>
												<path
													className="cls-13"
													d="m163.55,23.62c3.38-2.01,5.51-5.51,5.51-9.48,0-6.2-5.14-10.79-12.07-10.79h-12.91v34.17h6.9v-12.14h5.52l6.27,12.15h8.04l-7.25-13.92Zm-12.58-14.15h6.01c2.89,0,5.24,2.3,5.24,5.08,0,3.03-2.35,5.18-5.24,5.18h-6.01v-10.26Z"
												></path>
												<path
													className="cls-13"
													d="m85.66,18.18c-.36,1.45-.61,2.89-.76,4.38.42.2,1.37.57,1.39.57,2.59.96,5.79,1.52,8.88,1.51-1.52,3.87-5.15,6.92-10.38,6.92-6.16,0-10.81-4.88-10.81-11.13s4.79-11.13,11.2-11.13c4.2,0,6.16,1.83,9.25,5.18l5.96-3.36c-3.04-5.13-8.46-8.4-15.55-8.4-10.17,0-17.95,7.71-17.95,17.72s7.77,17.72,17.9,17.72,17.66-7.52,17.66-17.28v-2.7h-16.78Z"
												></path>
												<path className="cls-1" d="m43.52,56.92c2.21,0,4.01-1.79,4.01-4s-1.79-4-4.01-4-4.01,1.79-4.01,4,1.79,4,4.01,4Z"></path>
												<path className="cls-5" d="m17.18,11.37c2.21,0,4.01-1.79,4.01-4s-1.79-4-4.01-4-4.01,1.79-4.01,4,1.79,4,4.01,4Z"></path>
												<path className="cls-6" d="m56.69,34.14c2.21,0,4.01-1.79,4.01-4s-1.79-4-4.01-4-4.01,1.79-4.01,4,1.79,4,4.01,4Z"></path>
												<path className="cls-7" d="m4.01,34.14c2.21,0,4.01-1.79,4.01-4s-1.79-4-4.01-4-4.01,1.79-4.01,4,1.79,4,4.01,4Z"></path>
												<path className="cls-11" d="m17.18,56.92c2.21,0,4.01-1.79,4.01-4s-1.79-4-4.01-4-4.01,1.79-4.01,4,1.79,4,4.01,4Z"></path>
												<path className="cls-8" d="m43.52,11.37c2.21,0,4.01-1.79,4.01-4s-1.79-4-4.01-4-4.01,1.79-4.01,4,1.79,4,4.01,4Z"></path>
												<path
													className="cls-12"
													d="m2.61,42.46c6.87-.5,17.1-5.82,17.1-12.32S9.48,18.32,2.61,17.82c-.61,1.36-1.12,2.78-1.51,4.22l14.54,8.1L1.1,38.24c.39,1.42.9,2.83,1.51,4.22Z"
												></path>
												<path
													className="cls-10"
													d="m35.67,39.34c-5.64,3.25-5.14,14.75-2.13,20.94,1.47-.16,2.95-.42,4.41-.79l-.25-16.63,14.3,8.52c1.05-1.07,2.02-2.22,2.9-3.41-3.87-5.7-13.61-11.88-19.24-8.63Z"
												></path>
												<path
													className="cls-9"
													d="m23,17.43l-14.3-8.52c-1.05,1.07-2.02,2.22-2.9,3.41,3.86,5.69,13.6,11.88,19.24,8.62,5.64-3.25,5.14-14.75,2.13-20.94-1.47.16-2.95.42-4.41.79l.25,16.64Z"
												></path>
												<path
													className="cls-4"
													d="m45.06,30.14l14.54-8.1c-.39-1.42-.9-2.82-1.52-4.22-6.87.5-17.1,5.82-17.1,12.32s10.23,11.82,17.1,12.32c.61-1.36,1.12-2.78,1.51-4.22l-14.53-8.1Z"
												></path>
												<path
													className="cls-3"
													d="m25.03,39.34c-5.64-3.25-15.37,2.93-19.23,8.62.88,1.23,1.86,2.36,2.9,3.42l14.3-8.52-.25,16.62c1.44.37,2.92.65,4.41.8,3-6.19,3.49-17.69-2.14-20.94Z"
												></path>
												<path
													className="cls-2"
													d="m35.67,20.94c5.64,3.25,15.37-2.93,19.23-8.62-.88-1.23-1.86-2.36-2.9-3.42l-14.29,8.53.25-16.62c-1.44-.37-2.92-.65-4.41-.8-3.01,6.18-3.51,17.68,2.13,20.93Z"
												></path>
											</g>
										</svg> */}
									</a>
								</div>
							</div>
							<div className="col-6 text-end pt-lg-2 mt-1">
								<a href="https://www.ghreducation.com/" className="btn btn-top me-2 d-none d-lg-inline-block">
									GHR Education
								</a>
								<a href="https://www.ghrhealthcare.com/quick-apply" className="btn btn-top me-2 d-none d-lg-inline-block">
									Quick Apply
								</a>
								<a href="https://www.ghrhealthcare.com/ghrlive" className="btn btn-top d-none d-lg-inline-block">
									GHR Live!
								</a>
								<button
									className="navbar-toggler collapsed x d-lg-none"
									type="button"
									data-bs-toggle="offcanvas"
									data-bs-target="#mobile-nav"
									aria-controls="mobile-nav"
									aria-expanded="false"
									aria-label="Toggle navigation"
								>
									<span className="bar"></span>
									<span className="bar"></span>
									<span className="bar"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="top-nav d-none d-lg-block home">
					<div className="container-xxl g-0">
						<div className="row g-0">
							<nav className="navbar navbar-expand-lg justify-content-between ml-adj">
								<ul className="first-level nav justify-content-between">
									<li
										className={`dropdown ${hoveredDropdown === 'jobSeekers' ? 'show' : ''}`}
										onMouseEnter={() => handleMouseEnter('jobSeekers')}
										onMouseLeave={handleMouseLeave}
									>
										<a href="https://www.ghrhealthcare.com/job-opportunities" className="nav-one">
											Job Seekers
										</a>
										<div className={`dropdown-menu twocol ${hoveredDropdown === 'jobSeekers' ? 'show' : ''}`}>
											<div className="inner">
												<ul className="second-level bdr-end pe-3">
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/nursing">Nursing</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/allied-health">Allied Health</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/advanced-practice">Advanced Practice</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/physicians">Physicians</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/revcycle">Revenue Cycle Management (RCM)</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/healthcare-it">Healthcare IT</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/healthcare-leadership">Healthcare Leadership</a>
													</li>
												</ul>
												<ul className="second-level ps-3">
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/what-to-expect">What to Expect</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/pay-benefits">Pay &amp; Benefits</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/your-profile">Your Profile</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/download-app">Download App</a>
													</li>

													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/index">Job Opportunities</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/job-opportunities/quick-apply">Quick Apply</a>
													</li>
												</ul>
											</div>
										</div>
									</li>

									<li
										className={`dropdown ${hoveredDropdown === 'employers' ? 'show' : ''}`}
										onMouseEnter={() => handleMouseEnter('employers')}
										onMouseLeave={handleMouseLeave}
									>
										<a href="https://www.ghrhealthcare.com/staffing-solutions" className="nav-one">
											Employers
										</a>
										<div className={`dropdown-menu twocol ${hoveredDropdown === 'employers' ? 'show' : ''}`}>
											<div className="inner">
												<ul className="second-level bdr-end pe-3">
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/nurse-staffing">Nursing</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/allied-health-staffing">Allied Health</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/advanced-practice-staffing">Advanced Practice</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/physicians-staffing">Physicians</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/revenue-cycle-staffing">Revenue Cycle</a>
													</li>
												</ul>
												<ul className="second-level ps-3">
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/healthcare-it-staffing">Healthcare IT</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/index">Staffing Solutions</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/managed-service-provider">Managed Service Provider</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/direct-hire">Direct Hire</a>
													</li>
													<li>
														<a href="https://www.ghrhealthcare.com/staffing-solutions/consulting-services">Consulting Services</a>
													</li>
												</ul>
											</div>
										</div>
									</li>

									<li
										className={`dropdown ${hoveredDropdown === 'resources' ? 'show' : ''}`}
										onMouseEnter={() => handleMouseEnter('resources')}
										onMouseLeave={handleMouseLeave}
									>
										<a href="https://www.ghrhealthcare.com/blog" className="nav-one">
											Resources
										</a>
										<ul className={`dropdown-menu second-level ${hoveredDropdown === 'resources' ? 'show' : ''}`}>
											<li>
												<a href="https://www.ghrhealthcare.com/blog/index">Stories &amp; Resources</a>
											</li>
										</ul>
									</li>

									<li
										className={`dropdown ${hoveredDropdown === 'whyGHR' ? 'show' : ''}`}
										onMouseEnter={() => handleMouseEnter('whyGHR')}
										onMouseLeave={handleMouseLeave}
									>
										<a href="https://www.ghrhealthcare.com/about-us" className="nav-one">
											Why GHR
										</a>
										<ul className={`dropdown-menu second-level ${hoveredDropdown === 'whyGHR' ? 'show' : ''}`}>
											<li>
												<a href="https://www.ghrhealthcare.com/about-us/index">About Us</a>
											</li>
											<li>
												<a href="https://www.ghrhealthcare.com/about-us/our-approach">Our Approach</a>
											</li>
											<li>
												<a href="https://www.ghrhealthcare.com/about-us/corporate-careers">Corporate Careers</a>
											</li>
										</ul>
									</li>

									<li
										className={`dropdown ${hoveredDropdown === 'contact' ? 'show' : ''}`}
										onMouseEnter={() => handleMouseEnter('contact')}
										onMouseLeave={handleMouseLeave}
									>
										<a href="https://www.ghrhealthcare.com/contact" className="nav-one">
											Contact Us
										</a>
										<ul className={`dropdown-menu second-level ${hoveredDropdown === 'contact' ? 'show' : ''}`}>
											<li>
												<a href="https://www.ghrhealthcare.com/contact/index">Contact Us</a>
											</li>
											<li>
												<a href="https://www.ghrhealthcare.com/contact/locations">Locations</a>
											</li>
										</ul>
									</li>

									<li>
										<a href="https://www.ghrhealthcare.com/" className="open-search">
											<span className="icon-search"></span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</header>
			<div id="mobile-nav" className="offcanvas offcanvas-end d-print-none">
				<div className="mbl-cta">
					<a href="https://www.ghreducation.com/" className="btn btn-top d-block d-lg-none mb-3">
						GHR Education
					</a>
					<a href="https://www.ghrhealthcare.com/quick-apply" className="btn btn-top d-block mb-3 d-lg-none">
						Quick Apply
					</a>
					<a href="https://www.ghrhealthcare.com/ghrlive" className="btn btn-top d-block d-lg-none">
						GHR Live!
					</a>
				</div>
				<ul id="mblist" className="mobile-nav first">
					<li>
						<a href="https://www.ghrhealthcare.com/#mn-job-opportunities" className="collapsed" data-bs-toggle="collapse">
							Job Seekers
						</a>
						<ul id="mn-job-opportunities" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/nursing">Nursing</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/allied-health">Allied Health</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/advanced-practice">Advanced Practice</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/revcycle">Revenue Cycle Management (RCM)</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/healthcare-it">Healthcare IT</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/healthcare-leadership">Healthcare Leadership</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/index">Job Opportunities</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/what-to-expect">What to Expect</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/job-opportunities/pay-benefits">Pay &amp; Benefits</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghrhealthcare.com/#mn-staffing-solutions" className="collapsed" data-bs-toggle="collapse">
							Employers
						</a>
						<ul id="mn-staffing-solutions" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/nurse-staffing">Nursing</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/allied-health-staffing">Allied Health</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/advanced-practice-staffing">Advanced Practice</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/physicians-staffing">Physicians</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/revenue-cycle-staffing">Revenue Cycle</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/healthcare-it-staffing">Healthcare IT</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/index">Staffing Solutions</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/managed-service-provider">Managed Service Provider</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/direct-hire">Direct Hire</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/staffing-solutions/consulting-services">Consulting Services</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghrhealthcare.com/#mn-blog" className="collapsed" data-bs-toggle="collapse">
							Resources
						</a>
						<ul id="mn-blog" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghrhealthcare.com/blog/index">Stories &amp; Resources</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghrhealthcare.com/#mn-about-us" className="collapsed" data-bs-toggle="collapse">
							Why GHR
						</a>
						<ul id="mn-about-us" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghrhealthcare.com/about-us/index">About Us</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/about-us/our-approach">Our Approach</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/about-us/corporate-careers">Corporate Careers</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghrhealthcare.com/#mn-contact" className="collapsed" data-bs-toggle="collapse">
							Contact Us
						</a>
						<ul id="mn-contact" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghrhealthcare.com/contact/index">Contact Us</a>
							</li>
							<li>
								<a href="https://www.ghrhealthcare.com/contact/locations">Locations</a>
							</li>
						</ul>
					</li>
				</ul>
			</div>

			<script src="/assets/ghr/scripts/jquery.min.js" nonce=""></script>
			<script nonce="">
				{` $(function () {
        $(document).on("keyup", "#Phone", function () {
          $(this).val($(this).val().replace(/\D/g, "").substring(0, 10));
          var size = $(this).val().length;
          if (size > 0) {
            $(this).val("(" + $(this).val());
          }
          if (size > 3) {
            $(this).val(
              $(this).val().slice(0, 4) + ") " + $(this).val().slice(4)
            );
          }
          if (size > 6) {
            $(this).val(
              $(this).val().slice(0, 9) + "-" + $(this).val().slice(9)
            );
          }
        });
        var AcuteCareNursingOptions = ["RN", "LPN"];
        var AdvancedPracticeOptions = [
          "Audiologist",
          "CRNA",
          "Dentist",
          "Infection Preventionist",
          "MD",
          "Medical Laboratory Scientist",
          "Medical Physicist",
          "NP",
          "OT",
          "Pharmacist",
          "PharmD",
          "Physician Assistant",
          "Psychologist",
          "PT",
          "Registered Dietician",
          "RNFA",
        ];
        var AlliedHealthOptions = [
          "ABA",
          "Anesthesia Tech",
          "Audiologist",
          "BCBA",
          "CCMA",
          "CM",
          "CMA",
          "CNS",
          "COTA",
          "CRT",
          "CT Tech",
          "CV Tech",
          "Cath Lab Tech",
          "Clinical Director",
          "Clinical Nurse Educator",
          "Counselor",
          "Cyto Tech",
          "Dental Assistant",
          "Dentist",
          "Dietary Aide",
          "Dietitian",
          "EEG Tech",
          "EKG Tech",
          "EMG Tech",
          "EMT",
          "Echo Tech",
          "Endoscopy Technician",
          "Epidemiologist Specialist",
          "Exercise Physiologist",
          "Genetics Counselor",
          "Histo Tech",
          "IR Tech",
          "Infection Preventionist",
          "LPC",
          "Lab Manager",
          "Lab Tech",
          "MA",
          "MRI Tech",
          "Med Tech",
          "Medical Dosimetrist",
          "Medical Laboratory Scientist",
          "Medical Physicist",
          "NHA",
          "OR Tech",
          "OT",
          "PACS",
          "PCHA",
          "PT",
          "PT Aide",
          "PTA",
          "Pathology Assistant",
          "Pharm Tech",
          "PharmD",
          "Pharma Professional",
          "Pharmacist",
          "Phlebotomist",
          "Psych/MH Tech",
          "Psychologist",
          "Quality Assurance",
          "RRT",
          "Rad Tech",
          "Radiation Therapist",
          "Recreational Therapist",
          "Registered Dietician",
          "SLP",
          "SLPA",
          "Safety Specialist",
          "Sleep Tech",
          "Speech Language Specialist",
          "Sterile Processing Tech",
          "Surgical Tech",
          "Ultrasound Tech",
          "Vascular Tech",
          "Vision Therapist",
          "Xray Tech",
        ];
        var EducationOptions = [""];
        var HealthcareITOptions = [
          "ATE Support",
          "Business Analyst",
          "Business Intelligence Developer",
          "CIO",
          "CISO",
          "CMIO",
          "CTO",
          "Cloud Architect",
          "Cyber Security Analyst",
          "Data Analyst",
          "Data Architect",
          "Data Scientist",
          "Database Administrator",
          "ERP Analyst",
          "IT",
          "IT Administrator",
          "IT Analyst",
          "IT Clinical Analyst ",
          "IT Coordinator",
          "IT Developer",
          "IT Director",
          "IT Manager",
          "IT Trainer",
          "IT VP",
          "Network Administrator",
          "Program Manager",
          "Programmer",
          "Project Manager",
          "QA Lead ",
          "Report Writer",
        ];
        var LeadershipOptions = [
          "ADON",
          "CEO",
          "CFO",
          "CHRO",
          "CMO",
          "CNO",
          "COO",
          "CTO",
          "Clinical Director",
          "Clinical Nurse Educator",
          "DON",
          "DOR",
          "Director",
          "Executive Director",
          "Hematology Supervisor",
          "Lab Manager",
          "Manager",
          "VP",
        ];
        var NonAcuteCareNursingOptions = ["RN", "LPN", "ADON", "DON", "HHA"];
        var RevCycleRCMOptions = [
          "CDI Specialist",
          "Certified Coding Specialist (CCS)",
          "Clinical Documentation Specialist",
          "Coder",
          "Coding Auditor",
          "HIM Tech",
          "LCSW",
          "MSW",
          "Medical Coder",
          "Social Worker",
        ];
        var OtherOptions = ["Other (Specify Below)"];
        $(document).on("change", "#Discipline", function () {
          $("#Profession").html('<option value="">Profession*</option>');
          if ($(this).val() == "Acute Care Nursing") {
            AcuteCareNursingOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Advanced Practice") {
            AdvancedPracticeOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Allied Health") {
            AlliedHealthOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Education") {
            EducationOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Healthcare IT") {
            HealthcareITOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Leadership") {
            LeadershipOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Non Acute Care Nursing") {
            NonAcuteCareNursingOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "RevCycle (RCM)") {
            RevCycleRCMOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          } else if ($(this).val() == "Other (Specifiy Below)") {
            OtherOptions.forEach(function (item) {
              $("#Profession").append(
                '<option value="' + item + '">' + item + "</option>"
              );
            });
          }
        });
        $(document).on("click", ".selection-title", function () {
          $(".collapse").collapse("hide");
        });
        $(document).on("click", ".form-check-input", function (e) {
          $(this).parent().click();
        });
        $(document).on("click", ".area", function (e) {
          e.preventDefault();
          var Area = $(this).text();
          $(".clear-search").removeClass("d-none");
          $(".areas .main").addClass("hidden");
          $(".areas .second")
            .removeClass("hidden")
            .html(
              '<li className="menu-heading"><a href="" className="remove-area">' +
                Area +
                "</a></li>"
            );
          $.getJSON(
            "/assets/includes/categories",
            { area: Area },
            function (Categories) {
              $.each(Categories, function (Key, Category) {
                $(".areas .second").append(
                  '<li><a href="" className="select-link category">' +
                    Category +
                    "</a></li>"
                );
              });
              DistinctCategories();
            }
          );
          $("#FiltersArea").append(
            '<button className="btn-remove"><input type="hidden" name="area" value="' +
              Area +
              '"><span className="icon-close-circle remove-area-sel"></span> ' +
              Area +
              "</button>"
          );
          if ($("#FiltersJobTypes").children().length > 0)
            $("#FiltersJobTypes").prev().removeClass("d-none");
          if ($("#FiltersState").children().length > 0)
            $("#FiltersState").prev().removeClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".remove-area", function (e) {
          e.preventDefault();
          $(".areas .second").addClass("hidden");
          $(".areas .main").removeClass("hidden");
          $("#FiltersArea")
            .find('input[value="' + $(this).text() + '"]')
            .parent()
            .remove();
          $("#FiltersArea").next().addClass("d-none");
          $("#FiltersCategory").next().addClass("d-none");
          if ($("#FiltersJobTypes").children().length > 0)
            $("#FiltersJobTypes").prev().addClass("d-none");
          if (
            $("#FiltersState").children().length > 0 &&
            $("#FiltersJobTypes").children().length == 0
          )
            $("#FiltersState").prev().addClass("d-none");
          if (
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersState").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".remove-area-sel", function (e) {
          e.preventDefault();
          $(".areas .second").addClass("hidden");
          $(".areas .main").removeClass("hidden");
          $(".remove-specialty-sel").each(function () {
            $(this).parent().remove();
          });
          $(".remove-category-sel").parent().remove();
          $(this).parent().remove();
          $("#FiltersArea").next().addClass("d-none");
          $("#FiltersCategory").next().addClass("d-none");
          if ($("#FiltersJobTypes").children().length > 0)
            $("#FiltersJobTypes").prev().addClass("d-none");
          if (
            $("#FiltersState").children().length > 0 &&
            $("#FiltersJobTypes").children().length == 0
          )
            $("#FiltersState").prev().addClass("d-none");
          if (
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersState").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".category", function (e) {
          e.preventDefault();
          var Category = $(this).text();
          $(".areas .second").addClass("hidden");
          $(".areas .third")
            .removeClass("hidden")
            .html(
              '<li className="menu-heading"><a href="" className="remove-category">' +
                Category +
                "</a></li>"
            );
          $.getJSON(
            "/assets/includes/specialties",
            { category: Category },
            function (Specialties) {
              $.each(Specialties, function (Key, Specialty) {
                $(".areas .third").append(
                  '<li className="form-check specialty"><input className="form-check-input" type="checkbox" name="specialty" value="' +
                    Specialty +
                    '"><label className="form-check-label">' +
                    Specialty +
                    "</label></li>"
                );
              });
              DistinctSpecialties();
            }
          );
          $("#FiltersCategory").append(
            '<button className="btn-remove"><input type="hidden" name="category" value="' +
              Category +
              '"><span className="icon-close-circle remove-category-sel"></span> ' +
              Category +
              "</button>"
          );
          $("#FiltersCategory").prev().removeClass("d-none");
          if ($("#FiltersJobTypes").children().length > 0)
            $("#FiltersJobTypes").prev().removeClass("d-none");
          if ($("#FiltersState").children().length > 0)
            $("#FiltersState").prev().removeClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".remove-category", function (e) {
          e.preventDefault();
          $(".areas .third").addClass("hidden");
          $(".areas .second").removeClass("hidden");
          if ($("#FiltersSpecialties").children().length > 0)
            $("#FiltersSpecialties").prev().addClass("d-none");
          $(".remove-specialty-sel").each(function () {
            $(this).parent().remove();
          });
          $("#FiltersCategory")
            .find('input[value="' + $(this).text() + '"]')
            .parent()
            .remove();
          $("#FiltersCategory").prev().addClass("d-none");
          if ($("#FiltersJobTypes").children().length > 0)
            $("#FiltersJobTypes").prev().addClass("d-none");
          if (
            $("#FiltersState").children().length > 0 &&
            $("#FiltersJobTypes").children().length == 0
          )
            $("#FiltersState").prev().addClass("d-none");
          if (
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersState").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".remove-category-sel", function (e) {
          e.preventDefault();
          $(".areas .third").addClass("hidden");
          $(".areas .second").removeClass("hidden");
          if ($("#FiltersSpecialties").children().length > 0)
            $("#FiltersSpecialties").prev().addClass("d-none");
          $(".remove-specialty-sel").each(function () {
            $(this).parent().remove();
          });
          $(this).parent().remove();
          $("#FiltersCategory").prev().addClass("d-none");
          if ($("#FiltersJobTypes").children().length > 0)
            $("#FiltersJobTypes").prev().addClass("d-none");
          if (
            $("#FiltersState").children().length > 0 &&
            $("#FiltersJobTypes").children().length == 0
          )
            $("#FiltersState").prev().addClass("d-none");
          if (
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersState").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".specialty", function (e) {
          if ($(this).find("input").is(":checked")) {
            $(this).find("input").prop("checked", false);
            $("#FiltersSpecialties")
              .find('input[value="' + $(this).text() + '"]')
              .parent()
              .remove();
            if ($("#FiltersSpecialties").children().length == 0)
              $("#FiltersSpecialties").prev().addClass("d-none");
          } else {
            $(this).find("input").prop("checked", true);
            $("#FiltersSpecialties").append(
              '<button className="btn-remove"><input type="hidden" name="specialties[]" value="' +
                $(this).find("input").val() +
                '" /><span className="icon-close-circle remove-specialty-sel"></span> ' +
                $(this).find("input").val() +
                "</button>"
            );
            $("#FiltersSpecialties").prev().removeClass("d-none");
          }
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".remove-specialty-sel", function (e) {
          e.preventDefault();
          $(".specialty")
            .find('input[value="' + $(this).parent().text().trim() + '"]')
            .prop("checked", false);
          $(this).parent().remove();
          if ($("#FiltersSpecialties").children().length == 0)
            $("#FiltersSpecialties").prev().addClass("d-none");
          DistinctJobTypes();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".job-type", function (e) {
          if ($(this).find("input").is(":checked")) {
            $(this).find("input").prop("checked", false);
            $("#FiltersJobTypes")
              .find('input[value="' + $(this).find("input").val() + '"]')
              .parent()
              .remove();
            if (
              $("#FiltersJobTypes").children().length == 0 &&
              $("#FiltersArea").children().length > 0
            )
              $("#FiltersJobTypes").prev().addClass("d-none");
            if (
              $("#FiltersJobTypes").children().length == 0 &&
              $("#FiltersState").children().length > 0 &&
              $("#FiltersArea").children().length == 0
            )
              $("#FiltersJobTypes").next().addClass("d-none");
            if (
              $("#FiltersArea").children().length == 0 &&
              $("#FiltersJobTypes").children().length == 0 &&
              $("#FiltersState").children().length == 0
            )
              $(".clear-search").addClass("d-none");
          } else {
            $(".clear-search").removeClass("d-none");
            $(this).find("input").prop("checked", true);
            $("#FiltersJobTypes").append(
              '<button className="btn-remove"><input type="hidden" name="jobtypes[]" value="' +
                $(this).find("input").val() +
                '" /><span className="icon-close-circle remove-job-type-sel"></span> ' +
                $(this).find("input").val() +
                "</button>"
            );
            if ($("#FiltersArea").children().length > 0)
              $("#FiltersJobTypes").prev().removeClass("d-none");
            if (
              $("#FiltersState").children().length > 0 &&
              $("#FiltersArea").children().length == 0
            )
              $("#FiltersJobTypes").next().removeClass("d-none");
          }
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".remove-job-type-sel", function (e) {
          e.preventDefault();
          $(".job-type")
            .find('input[value="' + $(this).parent().text().trim() + '"]')
            .prop("checked", false);
          $(this).parent().remove();
          if (
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersArea").children().length > 0
          )
            $("#FiltersJobTypes").prev().addClass("d-none");
          if (
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersState").children().length > 0 &&
            $("#FiltersArea").children().length == 0
          )
            $("#FiltersJobTypes").next().addClass("d-none");
          if (
            $("#FiltersArea").children().length == 0 &&
            $("#FiltersJobTypes").children().length == 0 &&
            $("#FiltersState").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctStates();
          DistinctCities();
        });
        $(document).on("click", ".state", function (e) {
          e.preventDefault();
          var State = $(this).text();
          $(".clear-search").removeClass("d-none");
          $(".states .main").addClass("hidden");
          $(".states .second")
            .removeClass("hidden")
            .html(
              '<li className="menu-heading"><a href="" className="remove-state">' +
                State +
                "</a></li>"
            );
          $.getJSON(
            "/assets/includes/cities",
            { state: State },
            function (Cities) {
              $.each(Cities, function (Key, City) {
                if (City != "")
                  $(".states .second").append(
                    '<li className="form-check city"><input className="form-check-input" type="checkbox" name="city" value="' +
                      City +
                      '"><label className="form-check-label">' +
                      City +
                      "</label></li>"
                  );
              });
              DistinctCities();
            }
          );
          $("#FiltersState").append(
            '<button className="btn-remove"><input type="hidden" name="state" value="' +
              State +
              '"><span className="icon-close-circle remove-state-sel"></span> ' +
              State +
              "</button>"
          );
          if (
            $("#FiltersArea").children().length > 0 ||
            $("#FiltersJobTypes").children().length > 0
          )
            $("#FiltersState").prev().removeClass("d-none");
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctJobTypes();
        });
        $(document).on("click", ".remove-state", function (e) {
          e.preventDefault();
          $(".states .second").addClass("hidden");
          $(".states .main").removeClass("hidden");
          if ($("#FiltersCities").children().length > 0)
            $("#FiltersCities").prev().addClass("d-none");
          $(".remove-city-sel").each(function () {
            $(this).parent().remove();
          });
          $("#FiltersState")
            .find('input[value="' + $(this).text() + '"]')
            .parent()
            .remove();
          if (
            $("#FiltersArea").children().length > 0 ||
            $("#FiltersJobTypes").children().length > 0
          )
            $("#FiltersState").prev().addClass("d-none");
          if (
            $("#FiltersArea").children().length == 0 &&
            $("#FiltersJobTypes").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctJobTypes();
        });
        $(document).on("click", ".remove-state-sel", function (e) {
          e.preventDefault();
          $(".states .second").addClass("hidden");
          $(".states .main").removeClass("hidden");
          if ($("#FiltersCities").children().length > 0)
            $("#FiltersCities").prev().addClass("d-none");
          $(".remove-city-sel").each(function () {
            $(this).parent().remove();
          });
          $(this).parent().remove();
          $("#FiltersState")
            .find('input[value="' + $(this).text() + '"]')
            .parent()
            .remove();
          if (
            $("#FiltersArea").children().length > 0 ||
            $("#FiltersJobTypes").children().length > 0
          )
            $("#FiltersState").prev().addClass("d-none");
          if (
            $("#FiltersArea").children().length == 0 &&
            $("#FiltersJobTypes").children().length == 0
          )
            $(".clear-search").addClass("d-none");
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctJobTypes();
        });
        $(document).on("click", ".city", function (e) {
          if ($(this).find("input").is(":checked")) {
            $(this).find("input").prop("checked", false);
            $("#FiltersCities")
              .find('input[value="' + $(this).text() + '"]')
              .parent()
              .remove();
            if ($("#FiltersCities").children().length == 0)
              $("#FiltersCities").prev().addClass("d-none");
          } else {
            $(this).find("input").prop("checked", true);
            $("#FiltersCities").append(
              '<button className="btn-remove"><input type="hidden" name="cities[]" value="' +
                $(this).find("input").val() +
                '" /><span className="icon-close-circle remove-city-sel"></span> ' +
                $(this).find("input").val() +
                "</button>"
            );
            $("#FiltersCities").prev().removeClass("d-none");
          }
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctJobTypes();
        });
        $(document).on("click", ".remove-city-sel", function (e) {
          e.preventDefault();
          $(".city")
            .find('input[value="' + $(this).parent().text().trim() + '"]')
            .prop("checked", false);
          $(this).parent().remove();
          if ($("#FiltersCities").children().length == 0)
            $("#FiltersCities").prev().addClass("d-none");
          DistinctAreas();
          DistinctCategories();
          DistinctSpecialties();
          DistinctJobTypes();
        });
        $(document).on("click", "#ClearSearch", function (e) {
          e.preventDefault();
          $(".remove-area-sel").each(function () {
            $(this).click();
          });
          $(".remove-job-type-sel").each(function () {
            $(this).click();
          });
          $(".remove-state-sel").each(function () {
            $(this).click();
          });
        });
        $(document).on("click", "#ShowResults", function () {
          $(".collapse").collapse("hide");
          var Area = $("input[Name=area]").val();
          var Category = $("input[Name=category]").val();
          var Specialties = $("input[name='specialties[]']")
            .map(function () {
              return $(this).val();
            })
            .get();
          var JobTypes = $("input[name='jobtypes[]']")
            .map(function () {
              return $(this).val();
            })
            .get();
          var State = $("input[Name=state]").val();
          var Cities = $("input[name='cities[]']")
            .map(function () {
              return $(this).val();
            })
            .get();
          $.get(
            "/assets/includes/jobs-results",
            {
              area: Area,
              category: Category,
              specialties: Specialties,
              jobtypes: JobTypes,
              state: State,
              cities: Cities,
            },
            function (data) {
              $("#JobResults").html(data);
            }
          );
          $("html,body").animate(
            {
              scrollTop: $("#JobResultsSection").offset().top - 72,
            },
            300
          );
        });
        $(document).on("click", "#LoadMoreJobs", function (e) {
          e.preventDefault();
          $("#LoadMoreJobs").html('<img src="/images/loading.gif" />');
          $.get($(this).attr("href"), function (data) {
            $("#LoadMoreJobs").parent().replaceWith(data);
          });
        });
        $(document).on("click", "#ModifySearch", function (e) {
          e.preventDefault();
          $("html,body").animate(
            {
              scrollTop: 0,
            },
            300
          );
        });
        var Area = $("input[Name=area]").val();
        var Category = $("input[Name=category]").val();
        var Specialties = $("input[name='specialties[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var JobTypes = $("input[name='jobtypes[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var State = $("input[Name=state]").val();
        var Cities = $("input[name='cities[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        $.get(
          "/assets/includes/jobs-results",
          {
            area: Area,
            category: Category,
            specialties: Specialties,
            jobtypes: JobTypes,
            state: State,
            cities: Cities,
          },
          function (data) {
            $("#JobResults").html(data);
          }
        );
      });
      function DistinctAreas() {
        var Category = $("input[Name=category]").val();
        var Specialties = $("input[name='specialties[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var JobTypes = $("input[name='jobtypes[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var State = $("input[Name=state]").val();
        var Cities = $("input[name='cities[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        $(".area").each(function () {
          $(this).parent().hide();
        });
        $.getJSON(
          "/assets/includes/areas",
          {
            category: Category,
            specialties: Specialties,
            jobtypes: JobTypes,
            state: State,
            cities: Cities,
          },
          function (Areas) {
            $.each(Areas, function (Key, Area) {
              $('.area:contains("' + Area + '")')
                .parent()
                .show();
            });
          }
        );
      }
      function DistinctCategories() {
        var Area = $("input[Name=area]").val();
        var Specialties = $("input[name='specialties[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var JobTypes = $("input[name='jobtypes[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var State = $("input[Name=state]").val();
        var Cities = $("input[name='cities[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        $(".category").each(function () {
          $(this).parent().hide();
        });
        $.getJSON(
          "/assets/includes/categories",
          {
            area: Area,
            specialties: Specialties,
            jobtypes: JobTypes,
            state: State,
            cities: Cities,
          },
          function (Categories) {
            $.each(Categories, function (Key, Category) {
              $('.category:contains("' + Category + '")')
                .parent()
                .show();
            });
          }
        );
      }
      function DistinctSpecialties() {
        var Area = $("input[Name=area]").val();
        var Category = $("input[Name=category]").val();
        var JobTypes = $("input[name='jobtypes[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var State = $("input[Name=state]").val();
        var Cities = $("input[name='cities[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        $(".specialty").hide();
        $.getJSON(
          "/assets/includes/specialties",
          {
            area: Area,
            category: Category,
            jobtypes: JobTypes,
            state: State,
            cities: Cities,
          },
          function (Specialties) {
            $.each(Specialties, function (Key, Specialty) {
              $(".specialty")
                .find('input[value="' + Specialty + '"]')
                .parent()
                .show();
            });
          }
        );
      }
      function DistinctJobTypes() {
        var Area = $("input[Name=area]").val();
        var Category = $("input[Name=category]").val();
        var Specialties = $("input[name='specialties[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var State = $("input[Name=state]").val();
        var Cities = $("input[name='cities[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        $(".job-type").hide();
        $.getJSON(
          "/assets/includes/job-types",
          {
            area: Area,
            category: Category,
            specialties: Specialties,
            state: State,
            cities: Cities,
          },
          function (JobTypes) {
            $.each(JobTypes, function (Key, JobType) {
              $(".job-type")
                .find('input[value="' + JobType + '"]')
                .parent()
                .show();
            });
          }
        );
      }
      function DistinctStates() {
        var Area = $("input[Name=area]").val();
        var Category = $("input[Name=category]").val();
        var Specialties = $("input[name='specialties[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var JobTypes = $("input[name='jobtypes[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var Cities = $("input[name='cities[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        $(".state").each(function () {
          $(this).parent().hide();
        });
        $.getJSON(
          "/assets/includes/states",
          {
            area: Area,
            category: Category,
            specialties: Specialties,
            jobtypes: JobTypes,
            cities: Cities,
          },
          function (States) {
            $.each(States, function (Key, State) {
              State = State == "" ? "Other" : State;
              $('.state:contains("' + State + '")')
                .parent()
                .show();
            });
          }
        );
      }
      function DistinctCities() {
        var Area = $("input[Name=area]").val();
        var Category = $("input[Name=category]").val();
        var Specialties = $("input[name='specialties[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var JobTypes = $("input[name='jobtypes[]']")
          .map(function () {
            return $(this).val();
          })
          .get();
        var State = $("input[Name=state]").val();
        $(".city").hide();
        $.getJSON(
          "/assets/includes/cities",
          {
            area: Area,
            category: Category,
            specialties: Specialties,
            jobtypes: JobTypes,
            state: State,
          },
          function (Cities) {
            $.each(Cities, function (Key, City) {
              $(".city")
                .find('input[value="' + City + '"]')
                .parent()
                .show();
            });
          }
        );
      }`}
			</script>
			<script
				src="/assets/ghr/scripts/bootstrap.bundle.min.js"
				nonce=""
				integrity="sha384-HwwvtgBNo3bZJJLYd8oVXjrBZt8cqVSpeBNS5n7C8IVInixGAoxmnlMuBnhbgrkm"
				crossorigin="anonymous"
			></script>
			<script src="/assets/ghr/scripts/plugins.js" nonce=""></script>
			<script src="/assets/ghr/scripts/script.js" nonce=""></script>

			<script type="text/javascript" id="" charset="">
				{`   !(function (b, e, f, g, a, c, d) {
        b.fbq ||
          ((a = b.fbq =
            function () {
              a.callMethod
                ? a.callMethod.apply(a, arguments)
                : a.queue.push(arguments);
            }),
          b._fbq || (b._fbq = a),
          (a.push = a),
          (a.loaded = !0),
          (a.version = "2.0"),
          (a.queue = []),
          (c = e.createElement(f)),
          (c.async = !0),
          (c.src = g),
          (d = e.getElementsByTagName(f)[0]),
          d.parentNode.insertBefore(c, d));
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );
      fbq("init", "813742746898208");
      fbq("track", "PageView");
    </script>

 

    <script type="text/javascript" id="" charset="">
      var pageCount = parseInt(sessionStorage.getItem("pageCount")) || 0;
      pageCount++;
      sessionStorage.setItem("pageCount", pageCount);
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ event: "NewPageVisited", pageCount: pageCount });
    </script>
    <iframe
      height="0"
      width="0"
      style={{
        display: 'none',
        visibility: 'hidden'
      }}
      src="/assets/ghr/scripts/saved_resource.html"
    ></iframe>
    <script type="text/javascript" id="" charset="">
      (function (a, e, b, f, g, c, d) {
        a[b] =
          a[b] ||
          function () {
            (a[b].q = a[b].q || []).push(arguments);
          };
        c = e.createElement(f);
        c.async = 1;
        c.src = "https://www.clarity.ms/tag/" + g + "?ref\x3dgtm2";
        d = e.getElementsByTagName(f)[0];
        d.parentNode.insertBefore(c, d);
      })(window, document, "clarity", "script", "mvmrui0cqx");
    </script>
    <script>
      (function (a, b, c, d, e, m) {
        a["OktopostTrackerObject"] = d;
        a[d] =
          a[d] ||
          function () {
            (a[d].q = a[d].q || []).push(arguments);
          };
        e = b.createElement("script");
        m = b.getElementsByTagName("script")[0];
        e.async = 1;
        e.src =
          ("https:" === document.location.protocol ? "https://" : "http://") +
          c;
        m.parentNode.insertBefore(e, m);
      })(window, document, "static.oktopost.com/oktrk.js", "_oktrk");
      _oktrk("create", "001jydbzelwy1lb");
      `}
			</script>

			<script
				src="/assets/ghr/scripts/widget_app_base_1739794703874.js"
				async=""
				id="a11yWidgetSrc"
				crossorigin="anonymous"
				integrity="sha256-8/dvkPVcPvT5Y9oAdZQKvnTGr7k8GqON8QMhj3oTtqI="
			></script>
			<div id="veepn-breach-alert">
				<template shadowrootmode="open">
					<style>
						{`   .breach-popup {
            font-family: FigtreeVF, sans-serif;
            position: fixed;
            z-index: 2147483638;
            text-rendering: optimizelegibility;
            top: 0;
            left: 0;
            right: 0;
            pointer-events: none;
            padding-inline: 16px;
            height: 0;
            overflow: visible;
            color: #222e3a;
          }
          .breach-popup * {
            box-sizing: border-box;
          }
          .breach-popup__inner {
            background-color: #de4558;
            width: 100%;
            border-radius: 16px;
            margin-inline: auto;
            pointer-events: all;
            position: relative;
            transition: transform 0.25s ease-in-out, max-width 0.25s ease-in-out;
            transform: translateY(16px);
            max-height: calc(100svh - 80px);
            display: flex;
            flex-direction: column;
          }
          .breach-popup__header {
            min-height: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            column-gap: 16px;
            padding: 4px;
            cursor: pointer;
          }
          .breach-popup__close {
            cursor: pointer;
            background-color: transparent;
            border-style: none;
            outline: none;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            opacity: 0.5;
          }
          .breach-popup__wrap {
            display: grid;
            grid-template-rows: 0fr;
            transition: grid-template-rows 0.25s ease-in-out;
            overflow: hidden;
          }
          .breach-popup__content {
            overflow: hidden;
            opacity: 0;
            transform: translateY(-10px);
          }
          .breach-popup--minimize .breach-popup__inner {
            max-width: 485px;
            transform: translateY(-100%);
          }
          .breach-popup--collapse .breach-popup__inner {
            max-width: 485px;
          }
          .breach-popup--expand .breach-popup__inner {
            max-width: 1120px;
          }
          .breach-popup--expand .breach-popup__wrap {
            grid-template-rows: 1fr;
          }
          .breach-popup--expand .breach-popup__content {
            opacity: 1;
            transform: translateY(0);
            transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
            transition-delay: 0.15s;
          }
          .breach-popup--expand .breach-popup__header {
            cursor: default;
          }
          .breach-info {
            padding: 2px;
            height: 100%;
          }
          .breach-info__inner {
            padding: 22px 22px 0;
            background-color: #fff;
            border-bottom-left-radius: 15px;
            border-bottom-right-radius: 15px;
            height: 100%;
            overflow: auto;
          }
          .breach-info__alert {
            font-size: 24px;
            line-height: 32px;
            font-weight: 700;
            margin: 0;
          }
          .breach-info__list {
            margin-top: 24px;
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
          }
          @media only screen and (width >= 992px) {
            .breach-info__list {
              flex-wrap: nowrap;
            }
          }
          .breach-info__item {
            width: 100%;
          }
          .breach-info__item:nth-child(2) {
            max-width: 320px;
          }
          .breach-info__item:nth-child(3) {
            max-width: 200px;
          }
          .breach-info__title {
            font-size: 18px;
            font-weight: 700;
            line-height: 32px;
            letter-spacing: -0.1px;
            color: #de4558;
            margin-top: 0;
            margin-bottom: 4px;
          }
          .breach-info__description {
            font-size: 16px;
            line-height: 28px;
            letter-spacing: -0.1px;
          }
          .breach-info__description ul {
            margin: 0;
          }
          .breach-info__actions {
            display: flex;
            justify-content: center;
            padding-top: 32px;
            padding-bottom: 22px;
            background-color: #fff;
            position: sticky;
            bottom: 0;
          }
          .breach-info__btn {
            cursor: pointer;
            border-style: none;
            outline: none;
            display: inline-flex;
            align-items: center;
            height: 48px;
            padding-inline: 20px;
            border-radius: 12px;
            text-align: center;
            font-size: 16px;
            font-weight: 700;
            line-height: 28px;
            letter-spacing: -0.1px;
            color: #fff;
            background-color: #ff6400;
          }
          .button-expand {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 100%);
            z-index: 1;
          }
          .button-expand__pointer {
            cursor: pointer;
          }
          .button-expand__alert {
            pointer-events: none;
            transition: opacity 0.25s ease-in-out;
          }
          .button-expand__arrow {
            pointer-events: none;
            transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
            transform-origin: center;
          }
          .button-expand--minimize .button-expand__arrow,
          .button-expand--collapse .button-expand__alert,
          .button-expand--expand .button-expand__alert {
            opacity: 0;
          }
          .button-expand--expand .button-expand__arrow {
            transform: rotate(180deg);
          }
          .header-collapse {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            column-gap: 4px;
            padding-left: 8px;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: -0.1px;
            color: #fff;
          }
          .header-expand {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            column-gap: 4px;
            padding-left: 20px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: -0.1px;
            color: #fff;
          }`}
					</style>
				</template>
			</div>
			<style>
				{`   @font-face {
        font-family: FigtreeVF;
        src: url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2 supports variations"),
          url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2-variations");
        font-weight: 100 1000;
        font-display: swap;
      } `}
			</style>
			<div id="veepn-guard-alert">
				<template shadowrootmode="open">
					<style>
						{`        html {
            box-sizing: border-box;
            text-size-adjust: 100%;
            word-break: normal;
            -moz-tab-size: 4;
            tab-size: 4;
          }
          *,
          :before,
          :after {
            background-repeat: no-repeat;
            box-sizing: border-box;
          }
          :before,
          :after {
            text-decoration: inherit;
            vertical-align: inherit;
          }
          * {
            padding: 0;
            margin: 0;
          }
          hr {
            overflow: visible;
            height: 0;
            color: inherit;
            border: 0;
            border-top: 1px solid;
          }
          details,
          main {
            display: block;
          }
          summary {
            display: list-item;
          }
          small {
            font-size: 80%;
          }
          [hidden] {
            display: none;
          }
          abbr[title] {
            border-bottom: none;
            text-decoration: underline;
            text-decoration: underline dotted;
          }
          a {
            background-color: transparent;
          }
          a:active,
          a:hover {
            outline-width: 0;
          }
          code,
          kbd,
          pre,
          samp {
            font-family: monospace;
          }
          pre {
            font-size: 1em;
          }
          b,
          strong {
            font-weight: bolder;
          }
          sub,
          sup {
            font-size: 75%;
            line-height: 0;
            position: relative;
            vertical-align: baseline;
          }
          sub {
            bottom: -0.25em;
          }
          sup {
            top: -0.5em;
          }
          table {
            border-color: inherit;
            text-indent: 0;
          }
          iframe {
            border-style: none;
          }
          input {
            border-radius: 0;
          }
          [type="number"]::-webkit-inner-spin-button,
          [type="number"]::-webkit-outer-spin-button {
            height: auto;
          }
          [type="search"] {
            -webkit-appearance: textfield;
            -moz-appearance: textfield;
            appearance: textfield;
            outline-offset: -2px;
          }
          [type="search"]::-webkit-search-decoration {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
          textarea {
            overflow: auto;
            resize: vertical;
          }
          button,
          input,
          optgroup,
          select,
          textarea {
            font: inherit;
            color: inherit;
          }
          optgroup {
            font-weight: 700;
          }
          button {
            overflow: visible;
          }
          button,
          select {
            text-transform: none;
          }
          button,
          [type="button"],
          [type="reset"],
          [type="submit"],
          [role="button"] {
            cursor: pointer;
          }
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner {
            border-style: none;
            padding: 0;
          }
          button,
          html [type="button"],
          [type="reset"],
          [type="submit"] {
            -webkit-appearance: button;
            -moz-appearance: button;
            appearance: button;
          }
          button,
          input,
          select,
          textarea {
            background-color: transparent;
            border-style: none;
          }
          button:-moz-focusring,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner {
            outline: 1px dotted ButtonText;
          }
          select {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
          a:focus,
          button:focus,
          input:focus,
          select:focus,
          textarea:focus {
            outline-width: 0;
          }
          select::-ms-expand {
            display: none;
          }
          select::-ms-value {
            color: currentcolor;
          }
          legend {
            border: 0;
            color: inherit;
            display: table;
            white-space: normal;
            max-width: 100%;
          }
          ::-webkit-file-upload-button {
            -webkit-appearance: button;
            -moz-appearance: button;
            appearance: button;
            color: inherit;
            font: inherit;
          }
          [disabled] {
            cursor: default;
          }
          img {
            border-style: none;
          }
          progress {
            vertical-align: baseline;
          }
          [aria-busy="true"] {
            cursor: progress;
          }
          [aria-controls] {
            cursor: pointer;
          }
          [aria-disabled="true"] {
            cursor: default;
          }
          ul,
          ol {
            list-style-type: none;
          }
          figure {
            margin: 0;
          }
          .guard-popup {
            font-family: FigtreeVF, sans-serif;
            position: fixed;
            z-index: 2147483638;
            top: 8px;
            left: 24px;
            overflow: visible;
            color: #222e3a;
            background-color: #fff;
            max-width: 416px;
            width: calc(100% - 48px);
            border-radius: 16px;
            box-shadow: 0 4px 20px #00000040;
            padding: 24px;
          }
          .guard-popup__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            column-gap: 16px;
            margin-bottom: 24px;
          }
          .guard-popup__close {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            opacity: 0.7;
          }
          .guard-popup__img {
            line-height: 0;
            margin-bottom: 24px;
          }
          .guard-popup__img img {
            width: 100%;
            aspect-ratio: 368/142;
            object-fit: cover;
            border-radius: 12px;
            overflow: hidden;
          }
          .guard-popup__title {
            font-size: 24px;
            line-height: 32px;
            margin-bottom: 8px;
          }
          .guard-popup__description {
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
            color: #4a5764;
            margin-bottom: 28px;
          }
          .guard-popup__actions {
            display: flex;
            justify-content: flex-end;
            column-gap: 16px;
          }
          .guard-popup__btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 16px;
            border-radius: 5px;
            font-size: 16px;
            line-height: 24px;
            font-weight: 700;
            cursor: pointer;
            color: #fff;
            background: linear-gradient(180deg, #5695fd, #1554ff);
          }`}
					</style>
				</template>
			</div>
			<style>
				{`      @font-face {
        font-family: FigtreeVF;
        src: url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2 supports variations"),
          url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2)
            format("woff2-variations");
        font-weight: 100 1000;
        font-display: swap;
      } `}
			</style>
			<script
				crossorigin="anonymous"
				integrity="sha256-Lw4AFTYCz7uUZIz3B+RL+v8yUPwLSA+hbOqILL0MnMU="
				src="/assets/ghr/scripts/remediation_1739794703874.js"
			></script>
			<script
				crossorigin="anonymous"
				integrity="sha256-VeV7IJ5gs7ZrITsme9Lw7RsEyXcFNVYP8BQkd3MpWb0="
				src="/assets/ghr/scripts/widget_app_lazy_1739794703874.js"
			></script>
			<script crossorigin="anonymous" integrity="sha256-7kCHQO8+JS2mNgGdv2ckdb5EYLg2YuLJzQIOzypJD/o=" src="/assets/ghr/scripts/mini-widget.js"></script>
			<mini-widget>
				<template shadowrootmode="closed">
					<link type="text/css" rel="stylesheet" href="/assets/ghr/scripts/style(1).css" />
					<div>
						<div
							id="wrapper"
							className="mini-widget_wrapper__e5foii0 mini-widget_wrapperRight__e5foii5 mini-widget_wrapperRightBottom__e5foii8"
							style={{
								'--widgetGradientColor__7056on0': 'linear-gradient(to right, #1462ae, #0f74bc, #0a86ca, #0598d7, #00aae5)',
								'--textColor__7056on2': '#fff',
								'--miniMoveY__7056on3': '0px',
								transition: 'right 0.15s ease-out',
								right: '-235px',
							}}
						>
							<button id="toggleBtn" className="mini-widget_closeBtn__e5foiib">
								<svg width="35px" height="35px" viewBox="0 0 35 35" version="1.1">
									<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<g>
											<path
												className="mini-widget_fill__e5foiie"
												d="M24.8384449,13.123817 C25.0150402,13.0883074 25.1972576,13.093066 25.3717852,13.1377119 C25.5459585,13.1822493 25.7080944,13.2654493 25.8465773,13.3811816 C25.9844373,13.4964514 26.0952331,13.641082 26.1711216,13.8046245 C26.246723,13.9675482 26.2857143,14.1453448 26.2857143,14.3339484 C26.2798022,14.6264509 26.1736317,14.9080184 25.9850623,15.1303845 C25.7955359,15.3538791 25.5345503,15.5036214 25.2521874,15.5523408 C23.5306693,15.871353 21.79203,16.0867986 20.0468815,16.1974659 C19.9371268,16.204821 19.8299186,16.234837 19.7316402,16.2858208 C19.6329767,16.3369587 19.545403,16.408117 19.4742289,16.4951225 C19.4027488,16.5825021 19.349358,16.6840379 19.3174637,16.7933833 C19.3014938,16.8482011 19.2910613,16.9044475 19.2860211,16.9549572 L19.2824869,17.0255238 L19.2892305,17.1347169 L19.436766,18.4748318 C19.6210246,20.1238086 19.959813,21.7504679 20.4470467,23.3293732 L20.6367058,23.9191745 L20.8415253,24.5082219 L21.7941323,27.0989154 C21.8494214,27.2504569 21.8743842,27.4115283 21.8676091,27.5728398 C21.8608313,27.7342168 21.8224232,27.8926459 21.7545188,28.0390356 C21.6864753,28.1856548 21.5901819,28.3172006 21.4711715,28.4259501 C21.3517986,28.5350237 21.211936,28.6188909 21.0756836,28.6666025 C20.9402526,28.7205418 20.7960992,28.7488319 20.6389879,28.75 C20.4046724,28.7456426 20.1767863,28.6723624 19.9832125,28.5393771 C19.8749724,28.4650431 19.7798089,28.3736714 19.694933,28.2578403 L19.6133832,28.1335812 L19.5556774,28.0182992 L19.3124522,27.4898038 C18.6546007,26.051805 18.0538404,24.6428352 17.5057528,23.2469665 L17.2519145,22.5880826 L16.9242469,23.4367063 C16.7442825,23.8921435 16.5598773,24.3463206 16.3711464,24.7989662 L16.0848204,25.4767519 L15.6433546,26.4886774 L15.1883656,27.4927208 L14.9709428,27.9393116 C14.8587976,28.2431723 14.6318152,28.4899712 14.3393402,28.6249994 C14.0455819,28.76062 13.7104182,28.7720743 13.4083607,28.6567418 C13.1073719,28.5418882 12.8643289,28.3108489 12.732228,28.0150769 C12.6412441,27.8113653 12.6075937,27.5874931 12.637277,27.3522645 L12.6627351,27.209835 L12.7011878,27.0834232 L13.6527041,24.495544 C14.2170111,22.9385464 14.63197,21.3303567 14.8916824,19.6969397 L14.9817858,19.0832764 L15.0583162,18.4592047 L15.2109243,17.1259241 C15.224592,17.0115213 15.2152277,16.8954659 15.1834562,16.7850231 C15.1517099,16.6747733 15.0983435,16.5724517 15.0266867,16.4842444 C14.955378,16.3964657 14.8674534,16.3245257 14.7683854,16.2727411 C14.6696636,16.221153 14.5618614,16.1905935 14.4543576,16.1830274 C12.6930171,16.0713838 10.9397479,15.8526503 9.20536477,15.5282699 C9.04788066,15.4993594 8.89775792,15.4390888 8.76363311,15.3510035 C8.62989567,15.2631726 8.51483792,15.1495191 8.42489545,15.016528 C8.33528197,14.8839913 8.27248413,14.7349383 8.24005649,14.5781057 C8.20755016,14.4212976 8.20598886,14.259475 8.23427716,14.1082128 C8.26144886,13.949648 8.31950935,13.7980811 8.40521873,13.6621358 C8.4911527,13.5259447 8.6031895,13.4083623 8.73486832,13.3162633 C8.86691591,13.2239555 9.01598168,13.1593269 9.17331534,13.1262043 C9.33083367,13.0930429 9.49334082,13.0921884 9.64640746,13.1227853 C14.6696828,14.0666334 19.8205192,14.0666334 24.8384449,13.123817 Z M15.0910616,6.65693963 C16.2803962,5.44768791 18.211609,5.44768791 19.4009896,6.65693291 C20.5865505,7.86229437 20.5865505,9.81382574 19.400983,11.0191939 C18.2116038,12.2283839 16.2804013,12.2283839 15.0910748,11.0191939 C13.9054598,9.81383083 13.9054598,7.86228927 15.0910616,6.65693963 Z"
												fill-rule="nonzero"
											></path>
											<path
												className="mini-widget_stroke__e5foiif"
												d="M17.25,0.731818182 C21.81137,0.731818182 25.9409154,2.58067866 28.9301184,5.56988162 C31.9193213,8.55908459 33.7681818,12.68863 33.7681818,17.25 C33.7681818,21.81137 31.9193213,25.9409154 28.9301184,28.9301184 C25.9409154,31.9193213 21.81137,33.7681818 17.25,33.7681818 C12.68863,33.7681818 8.55908459,31.9193213 5.56988162,28.9301184 C2.58067866,25.9409154 0.731818182,21.81137 0.731818182,17.25 C0.731818182,12.68863 2.58067866,8.55908459 5.56988162,5.56988162 C8.55908459,2.58067866 12.68863,0.731818182 17.25,0.731818182 Z"
												stroke="#FFFFFF"
												stroke-width="1.46363636"
											></path>
										</g>
									</g>
								</svg>
							</button>
							<div className="mini-widget_header__e5foii9">
								<span className="mini-widget_title__e5foiia">Accessibility Menu</span>
							</div>

							<div className="mini-widget_features__e5foiic">
								<button name="feature-btn" title="Invert Colors" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="26px" height="25px" viewBox="0 0 26 25" aria-hidden="true">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												<g transform="translate(-794.000000, -276.000000)">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(36.964128, 67.500000)">
															<rect
																className="mini-widget_stroke__e5foiif"
																stroke-width="1.5"
																stroke-linecap="round"
																stroke-linejoin="round"
																x="0"
																y="0"
																width="24"
																height="16.9473684"
																rx="1.5"
															></rect>
															<path
																className="mini-widget_fill__e5foiie"
																d="M14.3865087,10.7298112 C13.0684659,12.0593689 10.9315341,12.0593689 9.61349127,10.7298112 C9.50195929,10.6172969 9.39986542,10.4988672 9.30720965,10.3755231 L14.8343277,6.47269233 C15.6821577,7.79191771 15.5328847,9.57333855 14.3865087,10.7298112 Z"
																fill-rule="nonzero"
															></path>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="7.2"
																y1="21.7894737"
																x2="16.8"
																y2="21.7894737"
																stroke-width="1.5"
																stroke-linecap="round"
																stroke-linejoin="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="12"
																y1="16.9473684"
																x2="12"
																y2="21.7894737"
																stroke-width="1.5"
																stroke-linecap="round"
																stroke-linejoin="round"
															></line>
															<path
																className="mini-widget_fill__e5foiie"
																d="M23.0550658,0 C23.1525245,-2.39947481e-16 23.2439099,0.0473418805 23.3001264,0.126952845 C23.3956977,0.262296059 23.3634562,0.449489263 23.228113,0.545060568 L1.18261789,16.1122742 C1.05605974,16.201642 0.904930861,16.2496228 0.75,16.2496228 C0.335786438,16.2496228 8.27882649e-16,15.9138364 0,15.4996228 L0,1.5 C-3.23497668e-16,0.671572875 0.671572875,-6.98650109e-17 1.5,0 Z M14.6911637,6.36547007 C13.5955549,4.85749392 11.474209,4.53099507 9.95300499,5.63621448 C8.43180098,6.74143389 8.0867879,8.85984745 9.1823967,10.3678236 Z"
															></path>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Invert Colors</span>
								</button>
								<button name="feature-btn" title="Dark Contrast" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg
											width="26px"
											height="24px"
											viewBox="0 0 26 24"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											stroke="none"
											stroke-width="1"
											fill="none"
											fill-rule="evenodd"
										>
											<g transform="translate(-36.000000, -387.000000)" fill-rule="nonzero">
												<g transform="translate(36.000000, 387.000000)">
													<path
														className="mini-widget_fill__e5foiie"
														d="M23.25,0 C24.4926407,0 25.5,1.00735931 25.5,2.25 L25.5,16.0866013 C25.5,17.329242 24.4926407,18.3366013 23.25,18.3366013 L13.5,18.336 L13.5,21.797 L17.5141276,21.7973856 C17.9283412,21.7973856 18.2641276,22.1331721 18.2641276,22.5473856 C18.2641276,22.9615992 17.9283412,23.2973856 17.5141276,23.2973856 L7.91412762,23.2973856 C7.49991406,23.2973856 7.16412762,22.9615992 7.16412762,22.5473856 C7.16412762,22.1331721 7.49991406,21.7973856 7.91412762,21.7973856 L12,21.797 L12,18.336 L2.25,18.3366013 C1.00735931,18.3366013 0,17.329242 0,16.0866013 L0,2.25 C0,1.00735931 1.00735931,0 2.25,0 L23.25,0 Z M12.75,5.25980392 C10.6789322,5.25980392 9,6.94239391 9,9.01797386 C9,11.0935538 10.6789322,12.7761438 12.75,12.7761438 C14.8210678,12.7761438 16.5,11.0935538 16.5,9.01797386 C16.5,6.94239391 14.8210678,5.25980392 12.75,5.25980392 Z"
													></path>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Dark Contrast</span>
								</button>
								<button name="feature-btn" title="Highlight Links" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="29px" height="13px" viewBox="0 0 29 13">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
												<g className="mini-widget_stroke__e5foiif" transform="translate(-793.000000, -448.000000)" stroke-width="1.75">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(35.964128, 235.000000)">
															<g transform="translate(0.000000, 4.000000)">
																<path d="M11.25,11 L4.22325,11 C1.89075,11 0,9.01921429 0,6.57564286 L0,4.42435714 C0,1.98078571 1.89075,0 4.22325,0 L11.25,0"></path>
																<path d="M15.75,0 L22.77675,0 C25.10925,0 27,1.98078571 27,4.42435714 L27,6.57564286 C27,9.01921429 25.10925,11 22.77675,11 L15.75,11"></path>
																<line x1="8.25" y1="5.5" x2="18.75" y2="5.5"></line>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Highlight Links</span>
								</button>
								<button name="feature-btn" title="Bigger Text" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="27px" height="18px" viewBox="0 0 27 18">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
												<g className="mini-widget_stroke__e5foiif" transform="translate(-794.000000, -500.000000)" stroke-width="1.5">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(36.964128, 290.000000)">
															<g transform="translate(0.000000, 1.000000)">
																<line x1="19" y1="15.483871" x2="19" y2="0" stroke-linejoin="round"></line>
																<polyline stroke-linejoin="round" points="13 3.09677419 13 0 25 0 25 3.09677419"></polyline>
																<line x1="16" y1="15.483871" x2="22" y2="15.483871"></line>
																<line x1="4" y1="13.4193548" x2="4" y2="3.09677419" stroke-linejoin="round"></line>
																<polyline
																	stroke-linejoin="round"
																	points="-1.11022302e-16 5.16129032 -1.11022302e-16 3.09677419 8 3.09677419 8 5.16129032"
																></polyline>
																<line x1="2" y1="13.4193548" x2="6" y2="13.4193548"></line>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Bigger Text</span>
								</button>
								<button name="feature-btn" title="Pause Animations" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="27px" height="27px" viewBox="0 0 27 27">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												<g transform="translate(-794.000000, -550.000000)">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(37.000000, 341.000000)">
															<path
																className="mini-widget_fill__e5foiie"
																d="M10.5211111,16.6666667 L9.58708333,16.6666667 C9.26138889,16.6666667 8.9975,16.4020833 8.9975,16.0763889 L8.9975,8.92361111 C8.9975,8.59791667 9.26138889,8.33333333 9.58708333,8.33333333 L10.5211111,8.33333333 C10.8468056,8.33333333 11.1113889,8.59791667 11.1113889,8.92361111 L11.1113889,16.0763889 C11.1113889,16.4020833 10.8468056,16.6666667 10.5211111,16.6666667"
															></path>
															<path
																className="mini-widget_fill__e5foiie"
																d="M15.4127083,16.6666667 L14.4786806,16.6666667 C14.1536806,16.6666667 13.8890972,16.4020833 13.8890972,16.0763889 L13.8890972,8.92361111 C13.8890972,8.59791667 14.1536806,8.33333333 14.4786806,8.33333333 L15.4127083,8.33333333 C15.7390972,8.33333333 16.0029861,8.59791667 16.0029861,8.92361111 L16.0029861,16.0763889 C16.0029861,16.4020833 15.7390972,16.6666667 15.4127083,16.6666667"
															></path>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="12.5"
																y1="2.77777778"
																x2="12.5"
																y2="0"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="12.5"
																y1="25"
																x2="12.5"
																y2="22.2222222"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="22.2222222"
																y1="12.5"
																x2="25"
																y2="12.5"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="0"
																y1="12.5"
																x2="2.77777778"
																y2="12.5"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="5.62541667"
																y1="5.62541667"
																x2="3.66083333"
																y2="3.66152778"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="21.3385417"
																y1="21.3385417"
																x2="19.3746528"
																y2="19.3746528"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="19.3745833"
																y1="5.62541667"
																x2="21.3384722"
																y2="3.66152778"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="3.66111111"
																y1="21.3385417"
																x2="5.62569444"
																y2="19.3746528"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="16.2163889"
																y1="3.51631944"
																x2="17.2781944"
																y2="0.949652778"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="7.72159722"
																y1="24.0505556"
																x2="8.78340278"
																y2="21.4838889"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="21.4836806"
																y1="16.2163889"
																x2="24.0503472"
																y2="17.2781944"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="0.949444444"
																y1="7.72159722"
																x2="3.51611111"
																y2="8.78340278"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="8.77548611"
																y1="3.51972222"
																x2="7.71159722"
																y2="0.95375"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="17.2885417"
																y1="24.0465278"
																x2="16.2246528"
																y2="21.4805556"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="21.4802778"
																y1="8.77548611"
																x2="24.04625"
																y2="7.71159722"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
															<line
																className="mini-widget_stroke__e5foiif"
																x1="0.953472222"
																y1="17.2885417"
																x2="3.51944444"
																y2="16.2246528"
																stroke-width="1.41666667"
																stroke-linecap="round"
															></line>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Pause Animations</span>
								</button>
								<button name="feature-btn" title="Legible Fonts" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="27px" height="18px" viewBox="0 0 27 18">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
												<g className="mini-widget_stroke__e5foiif" transform="translate(-794.000000, -500.000000)" stroke-width="1.5">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(36.964128, 290.000000)">
															<g transform="translate(0.000000, 1.000000)">
																<line x1="19" y1="15.483871" x2="19" y2="0" stroke-linejoin="round"></line>
																<polyline stroke-linejoin="round" points="13 3.09677419 13 0 25 0 25 3.09677419"></polyline>
																<line x1="16" y1="15.483871" x2="22" y2="15.483871"></line>
																<line x1="4" y1="13.4193548" x2="4" y2="3.09677419" stroke-linejoin="round"></line>
																<polyline
																	stroke-linejoin="round"
																	points="-1.11022302e-16 5.16129032 -1.11022302e-16 3.09677419 8 3.09677419 8 5.16129032"
																></polyline>
																<line x1="2" y1="13.4193548" x2="6" y2="13.4193548"></line>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Legible Fonts</span>
								</button>
								<button name="feature-btn" title="Big Cursor" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="20px" height="20px" viewBox="0 0 20 20">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
												<g className="mini-widget_stroke__e5foiif" transform="translate(-798.000000, -609.000000)" stroke-width="1.5">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(40.964128, 400.000000)">
															<polygon
																transform="translate(9.000000, 9.000000) rotate(-90.000000) translate(-9.000000, -9.000000) "
																points="10.2556821 11.0078065 3.26348858 18 0 14.7365114 6.99219354 7.74431788 0.339781676 4.7708152 18 -1.97574959e-14 13.2291848 17.6602183"
															></polygon>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Big Cursor</span>
								</button>
								<button name="feature-btn" title="Reset All" className="mini-widget_item__e5foiid" type="button">
									<span className="mini-widget_itemIcon__e5foiig">
										<svg width="25px" height="21px" viewBox="0 0 25 21">
											<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
												<g className="mini-widget_stroke__e5foiif" transform="translate(-795.000000, -663.000000)" stroke-width="1.6">
													<g transform="translate(758.000000, 210.000000)">
														<g transform="translate(38.000000, 454.000000)">
															<path d="M20.56614,9 C20.56614,10.381 20.3095101,11.696 19.8457431,12.893 C19.3819761,14.089 18.7110721,15.166 17.8816075,16.071 C17.0521429,16.976 16.0650342,17.708 14.9688577,18.214 C13.8717647,18.72 12.6665206,19 11.400785,19 C10.1350495,19 8.92980534,18.72 7.83271235,18.214 C6.73653589,17.708 5.74942717,16.976 4.91996254,16.071"></path>
															<path d="M2.23543007,10 C2.23543007,8.619 2.49206001,7.304 2.95582697,6.107 C3.41959393,4.911 4.09049792,3.834 4.91996254,2.929 C5.74942717,2.024 6.73653589,1.292 7.83271235,0.786 C8.92980534,0.28 10.1350495,0 11.400785,0 C12.6665206,0 13.8717647,0.28 14.9688577,0.786 C16.0650342,1.292 17.0521429,2.024 17.8816075,2.929"></path>
															<polyline stroke-linejoin="round" points="5.3113232 8.5156 1.94305525 10.6356 -2.21717924e-13 6.9606"></polyline>
															<polyline stroke-linejoin="round" points="17.6052721 10.1582 20.8369762 7.7982 23 11.3242"></polyline>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									<span className="mini-widget_itemTitle__e5foiih">Reset All</span>
								</button>
							</div>
							<span className="mini-widget_copy__e5foiii">
								Accessibility by
								<a
									className="mini-widget_copyLnk__e5foiij"
									href="https://userway.org/?utm_source=www.ghrhealthcare.com&amp;utm_medium=widget_footer&amp;utm_campaign=free_widget_mini"
									target="_blank"
								>
									UserWay.org
								</a>
							</span>
						</div>
					</div>
				</template>
			</mini-widget>
		</>
	)
}
